/* @flow */

import type { Config } from "shop-state/types";

const config: Config = {
  host: "localhost",
  port: 9435,
  apiHost: {
    server: "http://127.0.0.1",
    client: "",
    headers: ["SSL", "Ssl-Offload", "X-Forwarded-Proto", "Host", "X-Real-Ip", "X-Forwarded-For", "Cookie"],
  },
  googleAnalytics: [
    { store: "se", currencyCode: "SEK", accounts: ["G-H53EKSD22J"] },
  ],
  altapay: {
    src: "https://awardit.altapaysecure.com/checkout/v1/js/AltaPaySDK.js",
  },
  retrackEventId: '92cfed8e-11ac-4f14-8eff-efd1e8c4861f',
  datadog: {
    cspUri: null,
  }
};

module.exports = config;
